import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { LegacyInlineFormattingBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './LegacyInlineFormatting.module.css';
interface LegacyInlineFormattingProps {
  block: LegacyInlineFormattingBlock;
  blockId: string;
}

/**
 * Renders source legacy inline-formatting tags (`<font>`, `<center>`, `<u>`,
 * `<sub>`, `<sup>`, `<blockquote>`) as their semantic React equivalents per the
 * `legacyInlineRewrite` allowed transform. Color-bearing `<font>` content
 * should already have been promoted to `RichSegment.coloredText` upstream.
 */
export function LegacyInlineFormatting(t0) {
  const $ = _c(23);
  const {
    block,
    blockId
  } = t0;
  let t1;
  if ($[0] !== block.wrapper || $[1] !== blockId) {
    t1 = {
      "data-cms-block-id": blockId,
      "data-cms-field": "legacyInlineFormatting",
      "data-source-tag": block.wrapper
    };
    $[0] = block.wrapper;
    $[1] = blockId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const commonProps = t1;
  let t2;
  if ($[3] !== block.segments) {
    t2 = <RichSegments segments={block.segments} />;
    $[3] = block.segments;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const inner = t2;
  switch (block.wrapper) {
    case "u":
      {
        let t3;
        if ($[5] !== commonProps || $[6] !== inner) {
          t3 = <span {...commonProps} className={styles.underline}>{inner}</span>;
          $[5] = commonProps;
          $[6] = inner;
          $[7] = t3;
        } else {
          t3 = $[7];
        }
        return t3;
      }
    case "sub":
      {
        let t3;
        if ($[8] !== commonProps || $[9] !== inner) {
          t3 = <sub {...commonProps}>{inner}</sub>;
          $[8] = commonProps;
          $[9] = inner;
          $[10] = t3;
        } else {
          t3 = $[10];
        }
        return t3;
      }
    case "sup":
      {
        let t3;
        if ($[11] !== commonProps || $[12] !== inner) {
          t3 = <sup {...commonProps}>{inner}</sup>;
          $[11] = commonProps;
          $[12] = inner;
          $[13] = t3;
        } else {
          t3 = $[13];
        }
        return t3;
      }
    case "center":
      {
        let t3;
        if ($[14] !== commonProps || $[15] !== inner) {
          t3 = <div {...commonProps} className={styles.center}>{inner}</div>;
          $[14] = commonProps;
          $[15] = inner;
          $[16] = t3;
        } else {
          t3 = $[16];
        }
        return t3;
      }
    case "blockquote":
      {
        let t3;
        if ($[17] !== commonProps || $[18] !== inner) {
          t3 = <blockquote {...commonProps} className={styles.blockquote}>{inner}</blockquote>;
          $[17] = commonProps;
          $[18] = inner;
          $[19] = t3;
        } else {
          t3 = $[19];
        }
        return t3;
      }
    case "font":
    default:
      {
        let t3;
        if ($[20] !== commonProps || $[21] !== inner) {
          t3 = <span {...commonProps}>{inner}</span>;
          $[20] = commonProps;
          $[21] = inner;
          $[22] = t3;
        } else {
          t3 = $[22];
        }
        return t3;
      }
  }
}